export enum EColors {
  YELLOW = "YELLOW",
  RED = "RED",
  GREEN = "GREEN",
  BLUE = "BLUE",
  PURPLE = "PURPLE",
}
